import { BRAND, JOBS, MEASURE, SKUS } from '../marketingCopy';
import { AccessMapShot, ApprovalShot, SodShot } from '../ProductShots';

export default function LandingPage({ navigate, onSignIn, signedIn, onOpenApp }) {
  return (
    <div className="space-y-16">
      <section className="grid items-center gap-10 lg:grid-cols-2">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-cyan-400">{BRAND.partnerLine}</p>
          <h1 className="mt-2 text-3xl font-semibold tracking-tight text-orca-strong sm:text-4xl">{BRAND.product}</h1>
          <p className="mt-3 text-lg text-slate-300">{BRAND.category}</p>
          <p className="mt-2 text-sm text-slate-500">{BRAND.notThis}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={() => (signedIn ? onOpenApp?.() : onSignIn?.())}
              className="rounded-lg bg-cyan-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-cyan-500"
            >
              Sign in
            </button>
            <button
              type="button"
              onClick={() => navigate('/demo')}
              className="rounded-lg border border-cyan-600 px-4 py-2.5 text-sm font-semibold text-cyan-300 hover:bg-cyan-600/10"
            >
              Book a 20-minute demo
            </button>
            <button
              type="button"
              onClick={() => navigate('/demo-tour')}
              className="rounded-lg border border-orca bg-orca-raised px-4 py-2.5 text-sm font-medium text-orca-strong hover:brightness-110"
            >
              Watch the guided tour
            </button>
          </div>
          <p className="mt-3 text-xs text-slate-500">On your non-prod Fusion pod — or walk the three canned stories here.</p>
        </div>
        <AccessMapShot />
      </section>

      <section>
        <h2 className="text-xl font-semibold text-orca-strong">Three jobs. One workbench.</h2>
        <div className="mt-6 grid gap-6 md:grid-cols-3">
          {JOBS.map((job, i) => (
            <article key={job.id} className="rounded-2xl border border-orca bg-orca-panel p-5">
              <div className="text-[11px] font-semibold uppercase tracking-wide text-cyan-400">0{i + 1}</div>
              <h3 className="mt-2 text-base font-semibold text-orca-strong">{job.title}</h3>
              <p className="mt-1 text-xs text-slate-500">{job.buyer}</p>
              <p className="mt-3 text-sm text-slate-300">{job.outcome}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="grid gap-8 lg:grid-cols-2">
        <div>
          <h2 className="text-xl font-semibold text-orca-strong">Approvals without XPath first</h2>
          <p className="mt-2 text-sm text-slate-400">
            Describe the policy. Review the path. Simulate a worker. Deploy only when you intend to write to Fusion.
          </p>
        </div>
        <ApprovalShot />
      </section>

      <section className="grid gap-8 lg:grid-cols-2">
        <SodShot />
        <div className="lg:order-first">
          <h2 className="text-xl font-semibold text-orca-strong">SoD that leads to a review, not a slide</h2>
          <p className="mt-2 text-sm text-slate-400">
            Privilege-level HCM rules, a campaign, approve or revoke, optional sync back to Oracle. Complements — does not replace — Pathlock.
          </p>
        </div>
      </section>

      <section className="rounded-2xl border border-orca bg-orca-panel p-6">
        <h2 className="text-lg font-semibold text-orca-strong">{MEASURE.label}</h2>
        <ul className="mt-3 list-disc space-y-1 pl-5 text-sm text-slate-300">
          {MEASURE.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p className="mt-4 text-sm italic text-slate-500">{MEASURE.illustrative}</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-orca-strong">Packaging</h2>
        <p className="mt-1 text-sm text-slate-400">Three SKUs. One price unit: Fusion pod / year.</p>
        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {SKUS.map((sku) => (
            <article
              key={sku.id}
              className={`rounded-2xl border p-5 ${
                sku.featured ? 'border-cyan-600 bg-cyan-950/30' : 'border-orca bg-orca-panel'
              }`}
            >
              <h3 className="font-semibold text-orca-strong">{sku.name}</h3>
              <p className="mt-1 text-xs text-cyan-300">{sku.unit}</p>
              <ul className="mt-3 space-y-1 text-sm text-slate-300">
                {sku.includes.map((line) => (
                  <li key={line}>· {line}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
        <button
          type="button"
          onClick={() => navigate('/pricing')}
          className="mt-4 text-sm text-cyan-400 hover:text-cyan-300"
        >
          See units and what we quote →
        </button>
      </section>
    </div>
  );
}
